var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_c('main',[_c('h1',[_c('fa',{attrs:{"icon":"shield-alt"}}),_vm._v(" Berechtigungen")],1),_c('p',[_vm._v("TBD ENDPOINTS, FOR META not per User")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }